module.exports = __webpack_public_path__ + "img/lead_flow.8540e1a2.png";